module.exports = __webpack_public_path__ + "static/media/1717125674802-min.e9656315.JPG";